<template>
  <div class="dashboard__invoicelist">
    <p class="dashboard__invoicelist--title">{{dataList.title}}</p>
    <div v-if="isLoading" class="spinner__medium--blue
        dashboard__invoicelist--emptydata">
      <half-circle-spinner
        :animation-duration="1500"
        :size="50"
        color="#1D3354"
        class="mx-auto"
      />
    </div>
    <div v-else-if="dataList.data && dataList.data.length > 0">
      <div class="row m-0 py-2 dashboard__invoicelist--content" @click="invoiceDetail(item)"  v-for="(item, i) in dataList.data" :key="i">
        <div class="col-md-8 p-0">
          <p class="dashboard__invoicelist--numinvoice">{{item.invoice_number}}</p>
          <p class="dashboard__invoicelist--route">{{item.route}}</p>
        </div>
        <div class="col-md p-0 d-flex align-items-center justify-content-end">
          <b>{{item.overdue}}</b>
          <div class="ml-1">
            <img class="alert-image" :src="item.alertImage" alt="">
          </div>
        </div>
      </div>
      <div class="dashboard__invoicelist--footer text-center pt-2">
        <router-link tag="p" :to="dataList.link.route">
          {{dataList.link.text}}
        </router-link>
      </div>
    </div>
    <div v-else>
      <div class="dashboard__invoicelist--emptydata">
        <img :src="dataList.emptyData.image" alt="">
        <b class="mt-2">{{dataList.emptyData.text}}</b>
      </div>
      <div class="dashboard__invoicelist--footer text-center pt-2">
        <router-link tag="p" v-if="paymentList && paymentList.length > 0"
          :to="dataList.link.route">
          {{dataList.link.text}}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HalfCircleSpinner } from 'epic-spinners'

export default {
  name: 'DashboardInvoiceList',
  props: {
    dataList: Object,
    isLoading: Boolean
  },
  components: {
    HalfCircleSpinner
  },
  mounted () {
    this.fetchPaymentList()
  },
  computed: {
    ...mapGetters({
      paymentList: 'payment/items'
    })
  },
  methods: {
    invoiceDetail (item) {
      this.$router.push({
        name: 'PaymentDetail',
        params: {
          idInvoice: item.id_invoice,
          noInvoice: item.invoice_number.split('/').join('-'),
          type: 'pph'
        }
      })
    },
    async fetchPaymentList () {
      await this.$store.dispatch('payment/FETCH_PAYMENT_LIST')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/InvoiceList.vue